import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import AMCPackages from "@/pages/AMCPackages";
import Reviews from "@/pages/Reviews";
import Awards from "@/pages/Awards";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/amc-packages" element={<AMCPackages />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-center" richColors />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
